import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Body from "src/components/common/Body";
import Button from "src/components/common/Button";
import List from "src/components/common/List";
import IcoRadioChecked from "src/assets/images/icoRadioChecked.svg";
import styled from "styled-components";
import { useAlarmSettingListQuery, useSetAlarmMutation } from "src/api/alarmAPI";

function homeSetting() {
  const navigate = useNavigate();
  const alarmSetList = useAlarmSettingListQuery("");
  const { refetch } = useAlarmSettingListQuery("");
  const [setAlarmUpdate, { isError: setAlarmIsError, isSuccess: setAlarmIsSuccess }] = useSetAlarmMutation();

  useEffect(() => {
    if (setAlarmIsSuccess) {
      refetch();
    }
  }, [setAlarmIsSuccess]);

  useEffect(() => {
    if (setAlarmIsError || alarmSetList.isError) {
      navigate("/error");
    }
  }, [setAlarmIsError, alarmSetList.isError]);

  const alarmSet = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value === "notice") {
      setAlarmUpdate({
        push_type: "HOME-MAIN",
        YN: "NO",
      });
    } else {
      setAlarmUpdate({
        push_type: "HOME-MAIN",
        YN: "AS",
      });
    }
  };

  return (
    <>
      <header>
        <div>
          <Button variant="text" className="btn-back" onClick={() => navigate(-1)}>
            홈화면 설정
          </Button>
        </div>
      </header>

      <Body>
        <InfoMesBox>홈화면에서 먼저 띄울 서비스를 선택해주세요.</InfoMesBox>
        {alarmSetList.isSuccess && (
          <List bg="#f4f4f4" pd="15px" itemPd="18px 0" lastBd={false}>
            <ListRadio>
              <input type="radio" id="homeRadio01" name="homeRadio" value="notice" onChange={alarmSet} checked={alarmSetList.data.data.HOME_MAIN === "NO"} />
              <label htmlFor="homeRadio01">공지 먼저</label>
            </ListRadio>
            <ListRadio>
              <input type="radio" id="homeRadio02" name="homeRadio" value="as" onChange={alarmSet} checked={alarmSetList.data.data.HOME_MAIN === "AS"} />
              <label htmlFor="homeRadio02">A/S 먼저</label>
            </ListRadio>
          </List>
        )}
      </Body>
    </>
  );
}

const InfoMesBox = styled.p`
  padding: 30px 15px 24px;
  color: ${({ theme }) => theme.color.secondary};
  font-size: 16px;
`;

const ListRadio = styled.li`
  > label {
    position: relative;
    display: block;
    color: #000;
    font-size: 16px;
    font-weight: 500;
  }
  input {
    overflow: hidden;
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0px;
    border: 0px;
    margin: -1px;
    clip: rect(0px, 0px, 0px, 0px);
    appearance: none;
    &:checked {
      & + label {
        &:after {
          content: "";
          position: absolute;
          top: 50%;
          right: 0;
          display: block;
          width: 19px;
          height: 19px;
          margin-top: -10px;
          background: url(${IcoRadioChecked}) no-repeat 0 0;
        }
      }
    }
  }
`;

export default homeSetting;
